import { makeAutoObservable } from "mobx";

class GeneralStore {
	constructor() {
		makeAutoObservable(this);
	}

	public allAges: number[] = [
		1920, 1930, 1940, 1950, 1960, 1970, 1980, 1990, 2000, 2010, 2020,
	];
	private _ages: number[] = this.allAges;
	get ages() {
		return this._ages;
	}
	set ages(d: number[]) {
		this._ages = d;
	}

	private _currentAge: number = this.ages[0];
	private _requiredUpdateCurrentAge: boolean = false;
	get currentAge() {
		return this._currentAge;
	}
	set currentAge(d: number) {
		this._currentAge = d;
	}
	get requiredUpdateCurrentAge() {
		return this._requiredUpdateCurrentAge;
	}
	set requiredUpdateCurrentAge(d: boolean) {
		this._requiredUpdateCurrentAge = d;
	}
}
const generalStore = new GeneralStore();
export default generalStore;
